import SkeletonLoader from './index';
import TableSkeleton from './TableSkeleton';

const DashboardSkeleton = () => {
  return (
    <div className="flex flex-col gap-6 w-full animate-pulse">
      {/* Page Header */}
      <SkeletonLoader width={180} height={32} />

      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {[1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className="flex items-center gap-4 p-4 border border-neutral-200 rounded-xl"
          >
            <SkeletonLoader variant="circle" width={48} height={48} />
            <div className="flex flex-col gap-2 flex-1">
              <SkeletonLoader width={100} height={14} />
              <SkeletonLoader width={60} height={24} />
            </div>
          </div>
        ))}
      </div>

      {/* Chart Section */}
      <div className="border border-neutral-200 rounded-xl p-4">
        <SkeletonLoader width={140} height={20} className="mb-4" />
        <SkeletonLoader height={250} className="w-full" />
      </div>

      {/* Table Section */}
      <div className="border border-neutral-200 rounded-xl p-4">
        <SkeletonLoader width={180} height={20} className="mb-4" />
        <TableSkeleton />
      </div>
    </div>
  );
};

export default DashboardSkeleton;
